/* Gentle Beauty — journal article: reading progress, share, inline "shop the step" cards, sticky sidebar guard.
   Loaded with defer. Uses window.GB (gb-theme.js) and window.GB.pages (gb-pages.js) when available. */
(function () {
  'use strict';

  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  /* ---------- Reading progress ---------- */
  var progressState = null;
  function initProgress(root) {
    var bar = document.querySelector('[data-gb-article-progress]');
    var body = root.querySelector('[data-gb-article-body]');
    if (!bar || !body) return;
    var ticking = false;
    var update = function () {
      ticking = false;
      var r = body.getBoundingClientRect();
      var total = r.height - window.innerHeight * 0.5;
      var read = total > 0 ? (-r.top + window.innerHeight * 0.25) / total : 1;
      read = Math.max(0, Math.min(1, read));
      bar.style.setProperty('--gb-read', read.toFixed(4));
    };
    var onScroll = function () { if (!ticking) { ticking = true; window.requestAnimationFrame(update); } };
    if (progressState) {
      window.removeEventListener('scroll', progressState, { passive: true });
      window.removeEventListener('resize', progressState, { passive: true });
    }
    progressState = onScroll;
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  /* ---------- Share ---------- */
  function copyText(text) {
    if (window.GB && window.GB.pages && typeof window.GB.pages.copy === 'function') return window.GB.pages.copy(text);
    if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(text);
    return Promise.reject(new Error('no clipboard'));
  }

  function initShare(root) {
    $$('[data-gb-share]:not([data-init])', root).forEach(function (share) {
      share.setAttribute('data-init', '');
      var url = share.getAttribute('data-url') || window.location.href;
      var title = share.getAttribute('data-title') || document.title;
      var live = share.querySelector('[data-gb-share-live]');

      var nativeWrap = share.querySelector('[data-gb-share-native-wrap]');
      if (nativeWrap && navigator.share && window.matchMedia('(hover: none)').matches) nativeWrap.hidden = false;

      share.addEventListener('click', function (e) {
        var copyBtn = e.target.closest('[data-gb-share-copy]');
        if (copyBtn) {
          e.preventDefault();
          copyText(url).then(function () {
            var msg = share.getAttribute('data-copied') || '';
            copyBtn.classList.add('is-copied');
            if (live) { live.textContent = ''; setTimeout(function () { live.textContent = msg; }, 30); }
            if (window.GB && typeof window.GB.toast === 'function' && msg) window.GB.toast(msg);
            setTimeout(function () { copyBtn.classList.remove('is-copied'); }, 2400);
          }).catch(function () { window.prompt('', url); });
          return;
        }

        var nativeBtn = e.target.closest('[data-gb-share-native]');
        if (nativeBtn && navigator.share) {
          e.preventDefault();
          navigator.share({ title: title, url: url }).catch(function () {});
          return;
        }

        var popup = e.target.closest('[data-gb-share-popup]');
        if (popup && window.matchMedia('(hover: hover) and (min-width: 750px)').matches) {
          var w = 640, h = 560;
          var left = Math.max(0, (window.screen.width - w) / 2), top = Math.max(0, (window.screen.height - h) / 2);
          var win = window.open(popup.href, 'gbshare', 'noopener,width=' + w + ',height=' + h + ',left=' + left + ',top=' + top);
          if (win) e.preventDefault();
        }
      });
    });
  }

  /* ---------- Inline products: place card N at the end of heading section N ---------- */
  function initInlineProducts(root) {
    var holder = root.querySelector('[data-gb-inline-products]');
    var body = root.querySelector('[data-gb-article-body]');
    if (!holder || !body || holder.hasAttribute('data-init')) return;
    holder.setAttribute('data-init', '');
    var cards = $$('[data-gb-inline-product]', holder);
    var heads = $$(':scope > h2', body);
    if (!cards.length || heads.length < 2) return;
    var start = Math.max(1, parseInt(holder.getAttribute('data-start') || '1', 10));
    var placed = 0;
    cards.forEach(function (card, i) {
      var sectionIndex = start - 1 + i; // 0-based heading whose section receives the card
      var nextHead = heads[sectionIndex + 1];
      if (sectionIndex >= heads.length) return;
      if (nextHead) body.insertBefore(card, nextHead);
      else body.appendChild(card);
      placed++;
    });
    if (placed === cards.length) holder.classList.add('is-distributed');
    if (window.GB && typeof window.GB.init === 'function') window.GB.init(body);
  }

  /* ---------- Sticky sidebar guard (disable when taller than the viewport) ---------- */
  function initAside(root) {
    var aside = root.querySelector('[data-gb-article-aside]');
    if (!aside) return;
    var check = function () { aside.classList.toggle('is-tall', aside.offsetHeight > window.innerHeight - 140); };
    check();
    window.addEventListener('resize', check, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(check).observe(aside);
  }

  function init(scope) {
    var roots = $$('[data-gb-article]', scope || document);
    if (scope && scope.matches && scope.matches('[data-gb-article]')) roots.push(scope);
    roots.forEach(function (root) {
      initInlineProducts(root);
      initProgress(root);
      initShare(root);
      initAside(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
